import React from 'react';
import {HistoryAndState} from '../components/history/index'

const History = () =>
    <HistoryAndState/>;

export default History;

